const resList = [
    {
      info: {
        id: "78036",
        name: "Burger King",
        cloudinaryImageId: "e33e1d3ba7d6b2bb0d45e1001b731fcf",
        locality: "Central Plaza, Kalina",
        areaName: "Santacruz East",
        costForTwo: 35000,
        costForTwoString: "₹350 for two",
        deliveryTime: 24,
        cuisines: ["Burgers", "American"],
        avgRating: 4.2,
        feeDetails: {
          restaurantId: "78036",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 3200,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 3200,
        },
        parentId: "166",
        avgRatingString: "4.2",
        totalRatingsString: "10K+",
        sla: {
          lastMileTravel: 1.5,
          serviceability: "SERVICEABLE",
          slaString: "24 mins",
          lastMileTravelString: "1.5 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-30 03:45:00",
          opened: true,
        },
        badges: {},
        isOpen: true,
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {},
            textBased: {},
            textExtendedBadges: {},
          },
        },
        aggregatedDiscountInfoV3: {
          header: "ITEMS",
          subHeader: "AT ₹129",
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/burger-king-central-plaza-kalina-santacruz-east-mumbai-78036",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "32399",
        name: "McDonald's",
        cloudinaryImageId: "bb7ae131544c7d37e10fc5faf76f09d6",
        locality: "Kalina Artista",
        areaName: "Santacruz East",
  
        costForTwo: 40000,
        costForTwoString: "400 for two",
        deliveryTime: 17,
        cuisines: ["Burgers", "Beverages", "Cafe", "Desserts"],
        avgRating: 4.3,
        feeDetails: {
          restaurantId: "32399",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 3900,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 3900,
        },
        parentId: "630",
        avgRatingString: "4.3",
        totalRatingsString: "10K+",
        sla: {
          lastMileTravel: 1.5,
          serviceability: "SERVICEABLE",
          slaString: "17 mins",
          lastMileTravelString: "1.5 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-30 03:00:00",
          opened: true,
        },
        badges: {
          textExtendedBadges: [
            {
              iconId: "guiltfree/GF_Logo_android_3x",
              shortDescription: "options available",
              fontColor: "#7E808C",
            },
          ],
        },
        isOpen: true,
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {},
            textBased: {},
            textExtendedBadges: {
              badgeObject: [
                {
                  attributes: {
                    description: "",
                    fontColor: "#7E808C",
                    iconId: "guiltfree/GF_Logo_android_3x",
                    shortDescription: "options available",
                  },
                },
              ],
            },
          },
        },
        aggregatedDiscountInfoV3: {
          header: "10% OFF",
          subHeader: "ABOVE ₹1000",
          discountTag: "FLAT DEAL",
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/mcdonalds-kalina-artista-santacruz-east-mumbai-32399",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "82668",
        name: "The Belgian Waffle Co.",
        cloudinaryImageId: "846dab8cca3c56a482d7cbcda0dd0eb9",
        locality: "Kalina",
        areaName: "Santacruz East",
        costForTwoString: "₹200 for two",
        costForTwo: 20000,
        deliveryTime: 32,
        cuisines: ["Waffle", "Desserts", "Ice Cream", "Beverages"],
        avgRating: 4.3,
        veg: true,
        feeDetails: {
          restaurantId: "82668",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 3200,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 3200,
        },
        parentId: "2233",
        avgRatingString: "4.3",
        totalRatingsString: "1K+",
        sla: {
          lastMileTravel: 1.5,
          serviceability: "SERVICEABLE",
          slaString: "32 mins",
          lastMileTravelString: "1.5 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-30 04:00:00",
          opened: true,
        },
        badges: {},
        isOpen: true,
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {},
            textBased: {},
            textExtendedBadges: {},
          },
        },
        aggregatedDiscountInfoV3: {
          header: "40% OFF",
          subHeader: "UPTO ₹80",
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/the-belgian-waffle-co-kalina-santacruz-east-mumbai-82668",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "116963",
        name: "Monginis",
        cloudinaryImageId: "hyzmji0gto0g7hag9y3z",
        locality: "Kurla",
        areaName: "Saki Naka",
        costForTwoString: "₹300 for two",
        costForTwo: 30000,
        deliveryTime: 32,
        cuisines: ["Bakery", "Desserts", "Snacks"],
        avgRating: 4.4,
        feeDetails: {
          restaurantId: "116963",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 3400,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 3400,
        },
        parentId: "5007",
        avgRatingString: "4.4",
        totalRatingsString: "100+",
        sla: {
          deliveryTime: 22,
          lastMileTravel: 1,
          serviceability: "SERVICEABLE",
          slaString: "22 mins",
          lastMileTravelString: "1.0 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-29 20:00:00",
          opened: true,
        },
        badges: {},
        isOpen: true,
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {},
            textBased: {},
            textExtendedBadges: {},
          },
        },
        aggregatedDiscountInfoV3: {
          header: "20% OFF",
          subHeader: "UPTO ₹50",
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/monginis-kurla-saki-naka-mumbai-116963",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "11239",
        name: "Thambbi",
        cloudinaryImageId: "t6av3q7weumzdozcmowp",
        locality: "Opposite SBI Bank",
        areaName: "Kurla West",
        costForTwoString: "₹400 for two",
        costForTwo: 40000,
        deliveryTime: 24,
        cuisines: ["South Indian", "Punjabi", "Snacks", "Thalis"],
        avgRating: 4.4,
        veg: true,
        feeDetails: {
          restaurantId: "11239",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 3400,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 3400,
        },
        parentId: "2527",
        avgRatingString: "4.4",
        totalRatingsString: "10K+",
        sla: {
          lastMileTravel: 1.3,
          serviceability: "SERVICEABLE",
          slaString: "24 mins",
          lastMileTravelString: "1.3 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-29 23:00:00",
          opened: true,
        },
        badges: {
          textExtendedBadges: [
            {
              iconId: "guiltfree/GF_Logo_android_3x",
              shortDescription: "options available",
              fontColor: "#7E808C",
            },
          ],
        },
        isOpen: true,
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {},
            textBased: {},
            textExtendedBadges: {
              badgeObject: [
                {
                  attributes: {
                    description: "",
                    fontColor: "#7E808C",
                    iconId: "guiltfree/GF_Logo_android_3x",
                    shortDescription: "options available",
                  },
                },
              ],
            },
          },
        },
        aggregatedDiscountInfoV3: {
          header: "20% OFF",
          subHeader: "UPTO ₹50",
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/thambbi-opposite-sbi-bank-kurla-west-mumbai-11239",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "28405",
        name: "Chinese Wok",
        cloudinaryImageId: "e0839ff574213e6f35b3899ebf1fc597",
        locality: "CST Road",
        areaName: "Santacruz East",
        costForTwoString: "₹250 for two",
        costForTwo: 25000,
        deliveryTime: 22,
        cuisines: ["Chinese", "Asian", "Tibetan", "Desserts"],
        avgRating: 4.1,
        feeDetails: {
          restaurantId: "28405",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 3200,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 3200,
        },
        parentId: "61955",
        avgRatingString: "4.1",
        totalRatingsString: "10K+",
        sla: {
          lastMileTravel: 1.6,
          serviceability: "SERVICEABLE",
          slaString: "22 mins",
          lastMileTravelString: "1.6 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-30 01:00:00",
          opened: true,
        },
        badges: {},
        isOpen: true,
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {},
            textBased: {},
            textExtendedBadges: {},
          },
        },
        aggregatedDiscountInfoV3: {
          header: "EVERY ITEM",
          subHeader: "@ ₹149",
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/chinese-wok-cst-road-santacruz-east-mumbai-28405",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "15837",
        name: "PizzaExpress",
        cloudinaryImageId: "bb1d7cd7173f315487ed009ba7ca8b9d",
        locality: "Bandra Kurla Complex",
        areaName: "Bandra Kurla Complex",
        costForTwoString: "₹600 for two",
        costForTwo: 60000,
        deliveryTime: 32,
        cuisines: ["Pizzas", "Italian"],
        avgRating: 4,
        feeDetails: {
          restaurantId: "15837",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 4100,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 4100,
        },
        parentId: "3531",
        avgRatingString: "4.0",
        totalRatingsString: "1K+",
        sla: {
          lastMileTravel: 1.4,
          serviceability: "SERVICEABLE",
          slaString: "32 mins",
          lastMileTravelString: "1.4 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-30 00:45:00",
          opened: true,
        },
        badges: {
          imageBadges: [
            {
              imageId: "newg.png",
              description: "Gourmet",
            },
          ],
        },
        isOpen: true,
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {
              badgeObject: [
                {
                  attributes: {
                    description: "Gourmet",
                    imageId: "newg.png",
                  },
                },
              ],
            },
            textBased: {},
            textExtendedBadges: {},
          },
        },
        aggregatedDiscountInfoV3: {
          header: "10% OFF",
          subHeader: "ABOVE ₹1500",
          discountTag: "FLAT DEAL",
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/pizzaexpress-bandra-kurla-complex-mumbai-15837",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "9052",
        name: "Subway",
        cloudinaryImageId: "1ace5fa65eff3e1223feb696c956b38b",
        locality: "Central Plaza, Kalina",
        areaName: "Santacruz East",
        costForTwoString: "₹350 for two",
        costForTwo: 35000,
        deliveryTime: 22,
        cuisines: ["Salads", "Snacks", "Desserts", "Beverages"],
        avgRating: 4.2,
        feeDetails: {
          restaurantId: "9052",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 3200,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 3200,
        },
        parentId: "2",
        avgRatingString: "4.2",
        totalRatingsString: "10K+",
        sla: {
          lastMileTravel: 1.5,
          serviceability: "SERVICEABLE",
          slaString: "23 mins",
          lastMileTravelString: "1.5 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-30 04:00:00",
          opened: true,
        },
        badges: {
          textExtendedBadges: [
            {
              iconId: "guiltfree/GF_Logo_android_3x",
              shortDescription: "options available",
              fontColor: "#7E808C",
            },
          ],
        },
        isOpen: true,
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {},
            textBased: {},
            textExtendedBadges: {
              badgeObject: [
                {
                  attributes: {
                    description: "",
                    fontColor: "#7E808C",
                    iconId: "guiltfree/GF_Logo_android_3x",
                    shortDescription: "options available",
                  },
                },
              ],
            },
          },
        },
        aggregatedDiscountInfoV3: {
          header: "40% OFF",
          subHeader: "UPTO ₹80",
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/subway-central-plaza-kalina-santacruz-east-mumbai-9052",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "391816",
        name: "Louis Burger",
        cloudinaryImageId: "19d3d352cc815b9d88b22617b41fa97b",
        locality: "Trade Centre",
        areaName: "Santacruz Bandra east",
        costForTwoString: "₹600 for two",
        costForTwo: 60000,
        deliveryTime: 27,
        cuisines: ["Burgers", "American", "Fast Food"],
        avgRating: 4.3,
        feeDetails: {
          restaurantId: "391816",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 4100,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 4100,
        },
        parentId: "22485",
        avgRatingString: "4.3",
        totalRatingsString: "1K+",
        sla: {
          lastMileTravel: 1.4,
          serviceability: "SERVICEABLE",
          slaString: "25 mins",
          lastMileTravelString: "1.4 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-30 04:00:00",
          opened: true,
        },
        badges: {
          imageBadges: [
            {
              imageId: "newg.png",
              description: "Gourmet",
            },
          ],
        },
        isOpen: true,
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {
              badgeObject: [
                {
                  attributes: {
                    description: "Gourmet",
                    imageId: "newg.png",
                  },
                },
              ],
            },
            textBased: {},
            textExtendedBadges: {},
          },
        },
        aggregatedDiscountInfoV3: {
          header: "₹125 OFF",
          subHeader: "ABOVE ₹249",
          discountTag: "FLAT DEAL",
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/louis-burger-trade-centre-santacruz-bandra-east-mumbai-391816",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "395334",
        name: "McDonald's Gourmet Burger Collection",
        cloudinaryImageId: "txirbmikcfw5yijtcfs5",
        locality: "Kalina Artista",
        areaName: "Scruz Bandra East",
        costForTwoString: "₹600 for two",
        costForTwo: 60000,
        deliveryTime: 20,
        cuisines: ["Burgers", "Beverages", "Cafe", "Desserts"],
        avgRating: 3.8,
        feeDetails: {
          restaurantId: "395334",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 3900,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 3900,
        },
        parentId: "10761",
        avgRatingString: "3.8",
        totalRatingsString: "100+",
        sla: {
          deliveryTime: 17,
          lastMileTravel: 1.5,
          serviceability: "SERVICEABLE",
          slaString: "17 mins",
          lastMileTravelString: "1.5 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-30 03:00:00",
          opened: true,
        },
        badges: {},
        isOpen: true,
        aggregatedDiscountInfoV2: {},
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {},
            textBased: {},
            textExtendedBadges: {},
          },
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/mcdonalds-gourmet-burger-collection-kalina-artista-scruz-bandra-east-mumbai-395334",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "28721",
        name: "Oven Story Pizza - Standout Toppings",
        cloudinaryImageId: "f986df6f1a1fcf2ff24d2eaf44d570a7",
        locality: "Kalina",
        areaName: "Santacruz East",
        costForTwoString: "₹400 for two",
        costForTwo: 40000,
        deliveryTime: 26,
        cuisines: ["Pizzas", "Pastas", "Italian", "Desserts", "Beverages"],
        avgRating: 4,
        feeDetails: {
          restaurantId: "28721",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 4100,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 4100,
        },
        parentId: "3534",
        avgRatingString: "4.0",
        totalRatingsString: "1K+",
        sla: {
          lastMileTravel: 1.9,
          serviceability: "SERVICEABLE",
          slaString: "30-42 mins",
          lastMileTravelString: "1.9 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-29 23:59:00",
          opened: true,
        },
        badges: {},
        isOpen: true,
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {},
            textBased: {},
            textExtendedBadges: {},
          },
        },
        aggregatedDiscountInfoV3: {
          header: "60% OFF",
          subHeader: "UPTO ₹120",
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/oven-story-pizza-standout-toppings-kalina-santacruz-east-mumbai-28721",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "42885",
        name: "Rolls Mania",
        cloudinaryImageId: "g7donnzr1ev21elpr3nf",
        locality: "Santacruz East",
        areaName: "Santacruz East",
        costForTwoString: "₹200 for two",
        costForTwo: 20000,
        deliveryTime: 22,
        cuisines: ["Indian"],
        avgRating: 4.2,
        feeDetails: {
          restaurantId: "42885",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 3400,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 3400,
        },
        parentId: "171118",
        avgRatingString: "4.2",
        totalRatingsString: "1K+",
        sla: {
          deliveryTime: 25,
          lastMileTravel: 1.5,
          serviceability: "SERVICEABLE",
          slaString: "25 mins",
          lastMileTravelString: "1.5 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-30 03:30:00",
          opened: true,
        },
        badges: {},
        isOpen: true,
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {},
            textBased: {},
            textExtendedBadges: {},
          },
        },
        aggregatedDiscountInfoV3: {
          header: "50% OFF",
          subHeader: "UPTO ₹100",
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/rolls-mania-santacruz-east-mumbai-42885",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "156134",
        name: "The Good Bowl",
        cloudinaryImageId: "0b3356a88b6fc5966c452c4c9b1b5e4a",
        locality: "BKC FC",
        areaName: "Santacruz East",
        costForTwoString: "₹400 for two",
        costForTwo: 40000,
        deliveryTime: 32,
        cuisines: [
          "Biryani",
          "North Indian",
          "Pastas",
          "Punjabi",
          "Desserts",
          "Beverages",
        ],
        avgRating: 4.1,
        feeDetails: {
          restaurantId: "156134",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 3200,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 3200,
        },
        parentId: "7918",
        avgRatingString: "4.1",
        totalRatingsString: "1K+",
        sla: {
          deliveryTime: 26,
          lastMileTravel: 1.6,
          serviceability: "SERVICEABLE",
          slaString: "26 mins",
          lastMileTravelString: "1.6 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-29 23:59:00",
          opened: true,
        },
        badges: {},
        isOpen: true,
        aggregatedDiscountInfoV2: {},
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {},
            textBased: {},
            textExtendedBadges: {},
          },
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/the-good-bowl-bkc-fc-santacruz-east-mumbai-156134",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "202836",
        name: "Hangout Cakes & More",
        cloudinaryImageId: "51f9c55884b15013b2c8582505a1ee4f",
        locality: "CST Road",
        areaName: "Santacruz East",
        costForTwoString: "₹150 for two",
        costForTwo: 15000,
        deliveryTime: 22,
        cuisines: ["Bakery"],
        avgRating: 4.3,
        veg: true,
        feeDetails: {
          restaurantId: "202836",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 4100,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 4100,
        },
        parentId: "4508",
        avgRatingString: "4.3",
        totalRatingsString: "1K+",
        sla: {
          lastMileTravel: 1.5,
          serviceability: "SERVICEABLE",
          slaString: "22 mins",
          lastMileTravelString: "1.5 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-29 23:59:00",
          opened: true,
        },
        badges: {
          imageBadges: [
            {
              imageId: "v1695133679/badges/Pure_Veg111.png",
              description: "pureveg",
            },
          ],
        },
        isOpen: true,
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {
              badgeObject: [
                {
                  attributes: {
                    description: "pureveg",
                    imageId: "v1695133679/badges/Pure_Veg111.png",
                  },
                },
              ],
            },
            textBased: {},
            textExtendedBadges: {},
          },
        },
        aggregatedDiscountInfoV3: {
          header: "60% OFF",
          subHeader: "UPTO ₹120",
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/hangout-cakes-and-more-cst-road-santacruz-east-mumbai-202836",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "58396",
        name: "Apsara Ice Creams",
        cloudinaryImageId: "hal5rg4uzokxwbtwfrh5",
        locality: "CST Road",
        areaName: "Santacruz East",
        costForTwoString: "₹150 for two",
        costForTwo: 15000,
        deliveryTime: 22,
        cuisines: ["Ice Cream", "Desserts"],
        avgRating: 4.7,
        veg: true,
        feeDetails: {
          restaurantId: "58396",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 3200,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 3200,
        },
        parentId: "35219",
        avgRatingString: "4.7",
        totalRatingsString: "1K+",
        sla: {
          deliveryTime: 22,
          lastMileTravel: 1.5,
          serviceability: "SERVICEABLE",
          slaString: "22 mins",
          lastMileTravelString: "1.5 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-29 23:59:00",
          opened: true,
        },
        badges: {
          textExtendedBadges: [
            {
              iconId: "guiltfree/GF_Logo_android_3x",
              shortDescription: "options available",
              fontColor: "#7E808C",
            },
          ],
        },
        isOpen: true,
        aggregatedDiscountInfoV2: {},
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {},
            textBased: {},
            textExtendedBadges: {
              badgeObject: [
                {
                  attributes: {
                    description: "",
                    fontColor: "#7E808C",
                    iconId: "guiltfree/GF_Logo_android_3x",
                    shortDescription: "options available",
                  },
                },
              ],
            },
          },
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/apsara-ice-creams-cst-road-santacruz-east-mumbai-58396",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "17499",
        name: "Faasos - Wraps & Rolls",
        cloudinaryImageId: "af33b81798b11deba338e94b7585d348",
        locality: "Kalina",
        areaName: "Santacruz East",
        costForTwoString: "₹250 for two",
        costForTwo: 25000,
        deliveryTime: 28,
        cuisines: [
          "Kebabs",
          "Fast Food",
          "Snacks",
          "North Indian",
          "American",
          "Healthy Food",
          "Desserts",
          "Beverages",
        ],
        avgRating: 4.1,
        feeDetails: {
          restaurantId: "17499",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 3200,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 3200,
        },
        parentId: "21809",
        avgRatingString: "4.1",
        totalRatingsString: "10K+",
        sla: {
          deliveryTime: 28,
          lastMileTravel: 1.9,
          serviceability: "SERVICEABLE",
          slaString: "28 mins",
          lastMileTravelString: "1.9 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-29 23:59:00",
          opened: true,
        },
        badges: {
          textExtendedBadges: [
            {
              iconId: "guiltfree/GF_Logo_android_3x",
              shortDescription: "options available",
              fontColor: "#7E808C",
            },
          ],
        },
        isOpen: true,
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {},
            textBased: {},
            textExtendedBadges: {
              badgeObject: [
                {
                  attributes: {
                    description: "",
                    fontColor: "#7E808C",
                    iconId: "guiltfree/GF_Logo_android_3x",
                    shortDescription: "options available",
                  },
                },
              ],
            },
          },
        },
        aggregatedDiscountInfoV3: {
          header: "ITEMS",
          subHeader: "AT ₹99",
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/faasos-wraps-and-rolls-kalina-santacruz-east-mumbai-17499",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "62894",
        name: "LunchBox - Meals and Thalis",
        cloudinaryImageId: "pjobovhpe4jwxdxoe1ns",
        locality: "Kalina",
        areaName: "Santacruz East",
        costForTwoString: "₹200 for two",
        costForTwo: 20000,
        deliveryTime: 28,
        cuisines: [
          "Biryani",
          "North Indian",
          "Punjabi",
          "Healthy Food",
          "Desserts",
          "Beverages",
        ],
        avgRating: 4.1,
        feeDetails: {
          restaurantId: "62894",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 3200,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 3200,
        },
        parentId: "4925",
        avgRatingString: "4.1",
        totalRatingsString: "5K+",
        sla: {
          deliveryTime: 28,
          lastMileTravel: 1.9,
          serviceability: "SERVICEABLE",
          slaString: "28 mins",
          lastMileTravelString: "1.9 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-29 23:59:00",
          opened: true,
        },
        badges: {
          textExtendedBadges: [
            {
              iconId: "guiltfree/GF_Logo_android_3x",
              shortDescription: "options available",
              fontColor: "#7E808C",
            },
          ],
        },
        isOpen: true,
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {},
            textBased: {},
            textExtendedBadges: {
              badgeObject: [
                {
                  attributes: {
                    description: "",
                    fontColor: "#7E808C",
                    iconId: "guiltfree/GF_Logo_android_3x",
                    shortDescription: "options available",
                  },
                },
              ],
            },
          },
        },
        aggregatedDiscountInfoV3: {
          header: "ITEMS",
          subHeader: "AT ₹159",
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/lunchbox-meals-and-thalis-kalina-santacruz-east-mumbai-62894",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "337459",
        name: "Goodness To Go",
        cloudinaryImageId: "xnqmiqatrp5ki0k206o3",
        locality: "Bandra Kurla Complex",
        areaName: "Kurla",
        costForTwoString: "₹350 for two",
        costForTwo: 35000,
        deliveryTime: 32,
        cuisines: [
          "Salads",
          "European",
          "Italian",
          "Juices",
          "Bakery",
          "Desserts",
        ],
        avgRating: 4.2,
        feeDetails: {
          restaurantId: "337459",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 3200,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 3200,
        },
        parentId: "12021",
        avgRatingString: "4.2",
        totalRatingsString: "500+",
        sla: {
          deliveryTime: 34,
          lastMileTravel: 1.5,
          serviceability: "SERVICEABLE",
          slaString: "34 mins",
          lastMileTravelString: "1.5 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-29 23:30:00",
          opened: true,
        },
        badges: {},
        isOpen: true,
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {},
            textBased: {},
            textExtendedBadges: {},
          },
        },
        aggregatedDiscountInfoV3: {
          header: "₹125 OFF",
          subHeader: "ABOVE ₹249",
          discountTag: "FLAT DEAL",
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/goodness-to-go-bandra-complex-kurla-mumbai-337459",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "86155",
        name: "Kitchen Garden by Suzette",
        cloudinaryImageId: "bttsvynpr8x77z6hu9b1",
        locality: "BKC",
        areaName: "Scruz Bandra East",
        costForTwoString: "₹1100 for two",
        costForTwo: 110000,
        deliveryTime: 27,
        cuisines: ["Salads"],
        avgRating: 4.5,
        feeDetails: {
          restaurantId: "86155",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 4100,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 4100,
        },
        parentId: "5477",
        avgRatingString: "4.5",
        totalRatingsString: "1K+",
        sla: {
          deliveryTime: 27,
          lastMileTravel: 1.4,
          serviceability: "SERVICEABLE",
          slaString: "27 mins",
          lastMileTravelString: "1.4 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-29 19:30:00",
          opened: true,
        },
        badges: {},
        isOpen: true,
        aggregatedDiscountInfoV2: {},
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {},
            textBased: {},
            textExtendedBadges: {},
          },
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/kitchen-garden-by-suzette-bkc-scruz-bandra-east-mumbai-86155",
        type: "WEBLINK",
      },
    },
    {
      info: {
        id: "5691",
        name: "Smoke House Deli",
        cloudinaryImageId: "f5rgvghgew6hmnmbg3rn",
        locality: "Bandra Kurla Complex",
        areaName: "Bandra Kurla Complex",
        costForTwoString: "₹600 for two",
        costForTwo: 60000,
        deliveryTime: 36,
        cuisines: ["American", "Italian", "European"],
        avgRating: 4.3,
        feeDetails: {
          restaurantId: "5691",
          fees: [
            {
              name: "BASE_DISTANCE",
              fee: 4100,
            },
            {
              name: "BASE_TIME",
            },
            {
              name: "ANCILLARY_SURGE_FEE",
            },
          ],
          totalFee: 4100,
        },
        parentId: "874",
        avgRatingString: "4.3",
        totalRatingsString: "5K+",
        sla: {
          deliveryTime: 36,
          lastMileTravel: 1.5,
          serviceability: "SERVICEABLE",
          slaString: "36 mins",
          lastMileTravelString: "1.5 km",
          iconType: "ICON_TYPE_EMPTY",
        },
        availability: {
          nextCloseTime: "2023-11-29 23:30:00",
          opened: true,
        },
        badges: {
          imageBadges: [
            {
              imageId: "newg.png",
              description: "Gourmet",
            },
          ],
        },
        isOpen: true,
        type: "F",
        badgesV2: {
          entityBadges: {
            imageBased: {
              badgeObject: [
                {
                  attributes: {
                    description: "Gourmet",
                    imageId: "newg.png",
                  },
                },
              ],
            },
            textBased: {},
            textExtendedBadges: {},
          },
        },
        aggregatedDiscountInfoV3: {
          header: "60% OFF",
          subHeader: "UPTO ₹120",
        },
        differentiatedUi: {
          displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
          differentiatedUiMediaDetails: {
            mediaType: "ADS_MEDIA_ENUM_IMAGE",
            lottie: {},
            video: {},
          },
        },
        reviewsSummary: {},
        displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
        restaurantOfferPresentationInfo: {},
      },
      analytics: {},
      cta: {
        link: "https://www.swiggy.com/restaurants/smoke-house-deli-bandra-kurla-complex-mumbai-5691",
        type: "WEBLINK",
      },
    },
  ];

export default resList;